import type { EssentialModule } from "@/shared/types/estateEssentials";

// Values that are stored encrypted elsewhere and must never reach estate_tasks.answers.
export const SENSITIVE_ANSWER_KEYS = new Set([
  "deceased_ss_number",
  "user_ss_number",
  "deceased_passport_number",
]);

export function buildTaskAnswers(
  module: EssentialModule,
  data: Record<string, string>,
  isVehicleModule: boolean,
): Record<string, string> {
  if (isVehicleModule) {
    const transferKeys = new Set(
      (module.formFields ?? []).filter((f) => f.sectionGroup === "transfer_info").map((f) => f.key),
    );
    const answers: Record<string, string> = {};
    for (const [key, value] of Object.entries(data)) {
      if (!value || transferKeys.has(key) || SENSITIVE_ANSWER_KEYS.has(key)) continue;
      answers[key] = value;
    }
    return answers;
  }

  const sanitized: Record<string, string> = {};
  for (const [key, value] of Object.entries(data)) {
    if (SENSITIVE_ANSWER_KEYS.has(key)) continue;
    sanitized[key] = value;
  }
  return sanitized;
}
